import { useQuery } from "@tanstack/react-query";
import apiLeaveApprovalCount from "../../../../services/manager/leaveRequest/apiLeaveApprovalCount";

export default function LeaveApprovalCountQuery() {
  const {
    data,
    isLoading: leaveApprovalCountLoading,
    refetch: leaveApprovalCountRefetch,
  } = useQuery({
    queryKey: ["leaveApprovalCount"],
    queryFn: () => apiLeaveApprovalCount(),
  });

  const finalApprovalLeaveCount = data?.data.final_approval_count;
  const directReportLeaveCount = data?.data.direct_approval_count;

  console.log("leave count data", data?.data);

  return {
    finalApprovalLeaveCount,
    directReportLeaveCount,
    leaveApprovalCountLoading,
    leaveApprovalCountRefetch,
  };
}
